/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CreateIrrigationEvent400,
	CreateIrrigationEvent500,
	DeleteIrrigationEvent400,
	DeleteIrrigationEvent404,
	DeleteIrrigationEvent500,
	GetIrrigationEvent400,
	GetIrrigationEvent404,
	GetIrrigationEvent500,
	IrrigationEventCreate,
	IrrigationEventResponse,
	IrrigationEventUpdate,
	ListIrrigationEvents200,
	ListIrrigationEvents400,
	ListIrrigationEvents500,
	ListIrrigationEventsParams,
	UpdateIrrigationEvent400,
	UpdateIrrigationEvent404,
	UpdateIrrigationEvent500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListIrrigationEventsUrl = (
	params?: ListIrrigationEventsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/irrigation-events?${stringifiedParams}`
		: `/irrigation-events`;
};

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const listIrrigationEvents = async (
	params?: ListIrrigationEventsParams,
	options?: RequestInit,
): Promise<ListIrrigationEvents200> => {
	return customFetch<ListIrrigationEvents200>(
		getListIrrigationEventsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListIrrigationEventsQueryKey = (
	params?: ListIrrigationEventsParams,
) => {
	return ["irrigation-events", ...(params ? [params] : [])] as const;
};

export const getListIrrigationEventsQueryOptions = <
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListIrrigationEventsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listIrrigationEvents>>
	> = ({ signal }) =>
		listIrrigationEvents(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listIrrigationEvents>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListIrrigationEventsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listIrrigationEvents>>
>;
export type ListIrrigationEventsQueryError =
	| ListIrrigationEvents400
	| ListIrrigationEvents500;

export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params: undefined | ListIrrigationEventsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEvents>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEvents>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEvents>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEvents>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */

export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListIrrigationEventsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const useSetListIrrigationEventsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListIrrigationEventsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listIrrigationEvents>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listIrrigationEvents>> | undefined,
			  ) => Awaited<ReturnType<typeof listIrrigationEvents>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listIrrigationEvents>>
		>({ queryKey: getListIrrigationEventsQueryKey(params) }, updater);
	};
};

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const useGetListIrrigationEventsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListIrrigationEventsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listIrrigationEvents>>>(
			getListIrrigationEventsQueryKey(params),
		);
};

export const getCreateIrrigationEventUrl = () => {
	return `/irrigation-events`;
};

/**
 * @summary Create a one-time irrigation event from a start time
 */
export const createIrrigationEvent = async (
	irrigationEventCreate: IrrigationEventCreate,
	options?: RequestInit,
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(getCreateIrrigationEventUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(irrigationEventCreate),
	});
};

export const getCreateIrrigationEventMutationOptions = <
	TError = CreateIrrigationEvent400 | CreateIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createIrrigationEvent>>,
		TError,
		{ data: IrrigationEventCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createIrrigationEvent>>,
	TError,
	{ data: IrrigationEventCreate },
	TContext
> => {
	const mutationKey = ["createIrrigationEvent"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createIrrigationEvent>>,
		{ data: IrrigationEventCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createIrrigationEvent(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof createIrrigationEvent>>
>;
export type CreateIrrigationEventMutationBody = IrrigationEventCreate;
export type CreateIrrigationEventMutationError =
	| CreateIrrigationEvent400
	| CreateIrrigationEvent500;

/**
 * @summary Create a one-time irrigation event from a start time
 */
export const useCreateIrrigationEvent = <
	TError = CreateIrrigationEvent400 | CreateIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createIrrigationEvent>>,
			TError,
			{ data: IrrigationEventCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createIrrigationEvent>>,
	TError,
	{ data: IrrigationEventCreate },
	TContext
> => {
	return useMutation(
		getCreateIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getGetIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Get a single irrigation event by ID
 */
export const getIrrigationEvent = async (
	irrigationEventId: string,
	options?: RequestInit,
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getGetIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetIrrigationEventQueryKey = (irrigationEventId: string) => {
	return ["irrigation-events", irrigationEventId] as const;
};

export const getGetIrrigationEventQueryOptions = <
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetIrrigationEventQueryKey(irrigationEventId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getIrrigationEvent>>
	> = ({ signal }) =>
		getIrrigationEvent(irrigationEventId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: irrigationEventId !== null && irrigationEventId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getIrrigationEvent>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIrrigationEventQueryResult = NonNullable<
	Awaited<ReturnType<typeof getIrrigationEvent>>
>;
export type GetIrrigationEventQueryError =
	| GetIrrigationEvent400
	| GetIrrigationEvent404
	| GetIrrigationEvent500;

export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEvent>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEvent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEvent>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEvent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single irrigation event by ID
 */

export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetIrrigationEventQueryOptions(
		irrigationEventId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single irrigation event by ID
 */
export const useSetGetIrrigationEventQueryData = () => {
	const queryClient = useQueryClient();
	return (
		irrigationEventId: string,
		updater:
			| Awaited<ReturnType<typeof getIrrigationEvent>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getIrrigationEvent>> | undefined,
			  ) => Awaited<ReturnType<typeof getIrrigationEvent>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getIrrigationEvent>>>(
			{ queryKey: getGetIrrigationEventQueryKey(irrigationEventId) },
			updater,
		);
	};
};

/**
 * @summary Get a single irrigation event by ID
 */
export const useGetGetIrrigationEventQueryData = () => {
	const queryClient = useQueryClient();
	return (irrigationEventId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getIrrigationEvent>>>(
			getGetIrrigationEventQueryKey(irrigationEventId),
		);
};

export const getUpdateIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Update an existing irrigation event
 */
export const updateIrrigationEvent = async (
	irrigationEventId: string,
	irrigationEventUpdate: IrrigationEventUpdate,
	options?: RequestInit,
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getUpdateIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(irrigationEventUpdate),
		},
	);
};

export const getUpdateIrrigationEventMutationOptions = <
	TError =
		| UpdateIrrigationEvent400
		| UpdateIrrigationEvent404
		| UpdateIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateIrrigationEvent>>,
		TError,
		{ irrigationEventId: string; data: IrrigationEventUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateIrrigationEvent>>,
	TError,
	{ irrigationEventId: string; data: IrrigationEventUpdate },
	TContext
> => {
	const mutationKey = ["updateIrrigationEvent"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateIrrigationEvent>>,
		{ irrigationEventId: string; data: IrrigationEventUpdate }
	> = (props) => {
		const { irrigationEventId, data } = props ?? {};

		return updateIrrigationEvent(irrigationEventId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateIrrigationEvent>>
>;
export type UpdateIrrigationEventMutationBody = IrrigationEventUpdate;
export type UpdateIrrigationEventMutationError =
	| UpdateIrrigationEvent400
	| UpdateIrrigationEvent404
	| UpdateIrrigationEvent500;

/**
 * @summary Update an existing irrigation event
 */
export const useUpdateIrrigationEvent = <
	TError =
		| UpdateIrrigationEvent400
		| UpdateIrrigationEvent404
		| UpdateIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateIrrigationEvent>>,
			TError,
			{ irrigationEventId: string; data: IrrigationEventUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateIrrigationEvent>>,
	TError,
	{ irrigationEventId: string; data: IrrigationEventUpdate },
	TContext
> => {
	return useMutation(
		getUpdateIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getDeleteIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Delete a one-time irrigation event
 */
export const deleteIrrigationEvent = async (
	irrigationEventId: string,
	options?: RequestInit,
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getDeleteIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteIrrigationEventMutationOptions = <
	TError =
		| DeleteIrrigationEvent400
		| DeleteIrrigationEvent404
		| DeleteIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteIrrigationEvent>>,
		TError,
		{ irrigationEventId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>,
	TError,
	{ irrigationEventId: string },
	TContext
> => {
	const mutationKey = ["deleteIrrigationEvent"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteIrrigationEvent>>,
		{ irrigationEventId: string }
	> = (props) => {
		const { irrigationEventId } = props ?? {};

		return deleteIrrigationEvent(irrigationEventId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>
>;

export type DeleteIrrigationEventMutationError =
	| DeleteIrrigationEvent400
	| DeleteIrrigationEvent404
	| DeleteIrrigationEvent500;

/**
 * @summary Delete a one-time irrigation event
 */
export const useDeleteIrrigationEvent = <
	TError =
		| DeleteIrrigationEvent400
		| DeleteIrrigationEvent404
		| DeleteIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteIrrigationEvent>>,
			TError,
			{ irrigationEventId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>,
	TError,
	{ irrigationEventId: string },
	TContext
> => {
	return useMutation(
		getDeleteIrrigationEventMutationOptions(options),
		queryClient,
	);
};
